import { render, staticRenderFns } from "./SmallCard.vue?vue&type=template&id=588113a9&scoped=true&"
import script from "./SmallCard.vue?vue&type=script&lang=js&"
export * from "./SmallCard.vue?vue&type=script&lang=js&"
import style0 from "./SmallCard.vue?vue&type=style&index=0&id=588113a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588113a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588113a9')) {
      api.createRecord('588113a9', component.options)
    } else {
      api.reload('588113a9', component.options)
    }
    module.hot.accept("./SmallCard.vue?vue&type=template&id=588113a9&scoped=true&", function () {
      api.rerender('588113a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DasboardReportNMV/SmallCard.vue"
export default component.exports